(function ($) {
    function buildToggleMenu() {
        var site_menu = $("#site__menu");
        var menu_toggle = $("#toggle__menu");
        var close_menu = $("#close__menu");
        var body = $("body");
        var secondary_menus = site_menu.find("nav").not("#menu--primary");
        var brand_bar = $("#brand__bar");
        var panel_mega = $(".panel__mega");
        var resources_toggle = $("#toggle__resources");
        var logins_toggle = $("#toggle__logins");
        var personas_toggle = $("#toggle__personas");
        var resources_panel = $("#panel__resources");
        var logins_panel = $("#panel__logins");
        var personas_panel = $("#panel__personas");

        var focusTrapHandler = null;
        var brandBarOrigParent = null;
        var brandBarOrigPrev = null;

        function moveBrandBarIntoMenu() {
            if (brand_bar.parent()[0] === site_menu[0]) return;
            brandBarOrigParent = brand_bar.parent();
            brandBarOrigPrev = brand_bar.prev();
            site_menu.append(brand_bar);
        }

        function moveBrandBarOutOfMenu() {
            if (!brandBarOrigParent) return;
            if (brandBarOrigPrev && brandBarOrigPrev.length) {
                brandBarOrigPrev.after(brand_bar);
            } else {
                brandBarOrigParent.prepend(brand_bar);
            }
            brandBarOrigParent = null;
            brandBarOrigPrev = null;
        }

        // Open menu function
        function openMenu() {
            body.addClass("clip mobile-nav-shown");
            menu_toggle.addClass("toggle__menu--active");
            brand_bar.addClass("brand__bar--active");

            // A11y: Bring brand_bar inside site_menu so it falls within the aria-modal
            // scope (otherwise screen-reader virtual cursor arrow keys can't reach it).
            moveBrandBarIntoMenu();

            if ($("#menu--primary").length > 0) {
                site_menu.addClass("site__menu--active");

                resources_panel
                    .removeClass("panel__resources--active")
                    .attr("aria-hidden", "true");

                logins_panel
                    .removeClass("panel__logins--active")
                    .attr("aria-hidden", "true");

                personas_panel
                    .removeClass("panel__personas--active")
                    .attr("aria-hidden", "true");
                resources_toggle.removeClass("toggle__resources--active");
                logins_toggle.removeClass("toggle__logins--active");
                personas_toggle.removeClass("toggle__personas--active");
            }

            // Trap focus within the menu and brand bar toggles
            focusTrapHandler = function (e) {
                if (e.key !== "Tab") return;

                var focusableSelector =
                    'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

                // When a submenu is open, scope to active panel + mobile menu header
                var activePanel = site_menu.find(".panel__mega--active");
                var menuElements;
                if (activePanel.length > 0) {
                    var mobileHeader = site_menu.find(".mobile-menu-header");
                    menuElements = mobileHeader
                        .find(focusableSelector)
                        .add(activePanel.find(focusableSelector));
                } else {
                    menuElements = site_menu.find(focusableSelector);
                }

                // Include brand bar toggles in focus trap
                var barElements = brand_bar.find(focusableSelector);
                var focusableElements = menuElements
                    .add(barElements)
                    .filter(function () {
                        return this.checkVisibility({
                            visibilityProperty: true,
                        });
                    });

                if (focusableElements.length === 0) return;

                // Move to next/prev item manually — default Tab may land on
                // focusable elements outside the trap (e.g., primary menu
                // items behind an open submenu).
                var currentIdx = focusableElements.index(
                    document.activeElement
                );
                if (currentIdx === -1) return;

                var nextIdx;
                if (e.shiftKey) {
                    nextIdx =
                        (currentIdx - 1 + focusableElements.length) %
                        focusableElements.length;
                } else {
                    nextIdx = (currentIdx + 1) % focusableElements.length;
                }

                e.preventDefault();
                focusableElements[nextIdx].focus();
            };
            document.addEventListener("keydown", focusTrapHandler);

            // Move focus to close button
            setTimeout(function () {
                close_menu.focus();
            }, 100);
        }

        // Close menu function
        function closeMenu() {
            // Remove focus trap
            if (focusTrapHandler) {
                document.removeEventListener("keydown", focusTrapHandler);
                focusTrapHandler = null;
            }

            body.removeClass("clip mobile-nav-shown");
            menu_toggle.removeClass("toggle__menu--active");
            brand_bar.removeClass("brand__bar--active");

            moveBrandBarOutOfMenu();

            if ($("#menu--primary").length > 0) {
                site_menu.removeClass("site__menu--active");
                // Close any open quick links/submenu panels
                panel_mega.removeClass("panel__mega--active");
                updateSubmenuInert();
            }

            // Close quick links, logins, and personas panels and reset aria attributes
            resources_panel
                .removeClass("panel__resources--active")
                .attr("aria-hidden", "true");
            logins_panel
                .removeClass("panel__logins--active")
                .attr("aria-hidden", "true");
            personas_panel
                .removeClass("panel__personas--active")
                .attr("aria-hidden", "true");
            resources_toggle
                .removeClass("toggle__resources--active")
                .attr("aria-expanded", "false");
            logins_toggle
                .removeClass("toggle__logins--active")
                .attr("aria-expanded", "false");
            personas_toggle
                .removeClass("toggle__personas--active")
                .attr("aria-expanded", "false");

            // Return focus to hamburger button
            menu_toggle.focus();
        }

        // Hamburger button opens menu
        menu_toggle.click(function () {
            openMenu();
        });

        // Close button closes menu
        close_menu.click(function () {
            closeMenu();
        });

        // Store closeMenu function globally so escapeToggles can use it
        window.closeMobileMenu = closeMenu;
    }

    function destroyToggleMenu() {
        var menu_toggle = $("#toggle__menu");
        var site_menu = $("#site__menu");
        var secondary_menus = site_menu.find("nav").not(":first-child");

        // Unbind menu toggle & remove
        menu_toggle.unbind("click").remove();
    }

    function buildBrandBar() {
        var search_toggle = $("#toggle__search");
        var alert_toggle = $("#toggle__alert");
        var search_panel = $("#panel__search");

        var brand_bar = $("#brand__bar");

        // Move components from site bar to brand bar
        alert_toggle.prependTo(brand_bar.children(".wrapper"));
        search_toggle.appendTo(brand_bar.children(".wrapper"));

        // Add panels to brand bar
        search_panel.insertAfter(brand_bar);
    }

    function brandToggles() {
        var logins_panel = $("#panel__logins");
        var resources_panel = $("#panel__resources");
        var personas_panel = $("#panel__personas");
        var brand_bar = $("#brand__bar");
        var search_toggle = $("#toggle__search");
        var search_panel = $("#panel__search");

        //--------------------------------------------------------------------------

        var resources_toggle = $("#toggle__resources");

        // Toggle resources panel when tapping button
        resources_toggle.click(function () {
            var panel_height = resources_panel.outerHeight();

            if (
                $("#menu--primary").length > 0 &&
                $(this).hasClass("toggle__resources--active")
            ) {
                resources_toggle
                    .attr("aria-expanded", "false")
                    .removeClass("toggle__resources--active");
                resources_panel
                    .attr("aria-hidden", "true")
                    .removeClass("panel__resources--active");
                brand_bar.removeAttr("style");
            } else if (
                $("#menu--primary").length < 1 &&
                $(window).width() > 959 &&
                $(this).hasClass("toggle__resources--active")
            ) {
                resources_toggle
                    .attr("aria-expanded", "false")
                    .removeClass("toggle__resources--active");
                resources_panel
                    .attr("aria-hidden", "true")
                    .removeClass("panel__resources--active");
                brand_bar.removeAttr("style");
            } else {
                logins_toggle
                    .attr("aria-expanded", "false")
                    .removeClass("toggle__logins--active");
                logins_panel
                    .attr("aria-hidden", "true")
                    .removeClass("panel__logins--active");
                personas_toggle
                    .attr("aria-expanded", "false")
                    .removeClass("toggle__personas--active");
                personas_panel
                    .attr("aria-hidden", "true")
                    .removeClass("panel__personas--active");
                search_toggle
                    .attr("aria-expanded", "false")
                    .removeClass("toggle__search--active");
                search_panel
                    .removeClass("panel__search--active");

                resources_toggle
                    .attr("aria-expanded", "true")
                    .addClass("toggle__resources--active");
                resources_panel
                    .attr("aria-hidden", "false")
                    .addClass("panel__resources--active");
                brand_bar.css("margin-top", panel_height);
            }

            $("#menu--resources").on("focusout", function (event) {
                if (!this.contains(event.relatedTarget)) {
                    resources_panel
                        .removeClass("panel__resources--active")
                        .attr("aria-hidden", "true");
                    resources_toggle
                        .removeClass("toggle__resources--active")
                        .attr("aria-expanded", "false");
                    brand_bar.removeAttr("style");
                }
            });
        });

        //--------------------------------------------------------------------------

        var logins_toggle = $("#toggle__logins");

        // Toggle logins panel when tapping button
        logins_toggle.click(function () {
            var panel_height = logins_panel.outerHeight();

            if (
                $("#menu--primary").length > 0 &&
                $(this).hasClass("toggle__logins--active")
            ) {
                logins_toggle
                    .attr("aria-expanded", "false")
                    .removeClass("toggle__logins--active");
                logins_panel
                    .attr("aria-hidden", "true")
                    .removeClass("panel__logins--active");
                brand_bar.removeAttr("style");
            } else if (
                $("#menu--primary").length < 1 &&
                $(window).width() > 959 &&
                $(this).hasClass("toggle__logins--active")
            ) {
                logins_toggle
                    .attr("aria-expanded", "false")
                    .removeClass("toggle__logins--active");
                logins_panel
                    .attr("aria-hidden", "true")
                    .removeClass("panel__logins--active");
                brand_bar.removeAttr("style");
            } else {
                resources_toggle
                    .attr("aria-expanded", "false")
                    .removeClass("toggle__resources--active");
                resources_panel
                    .attr("aria-hidden", "true")
                    .removeClass("panel__resources--active");
                personas_toggle
                    .attr("aria-expanded", "false")
                    .removeClass("toggle__personas--active");
                personas_panel
                    .attr("aria-hidden", "true")
                    .removeClass("panel__personas--active");
                search_toggle
                    .attr("aria-expanded", "false")
                    .removeClass("toggle__search--active");
                search_panel
                    .removeClass("panel__search--active");

                logins_toggle
                    .attr("aria-expanded", "true")
                    .addClass("toggle__logins--active");
                logins_panel
                    .attr("aria-hidden", "false")
                    .addClass("panel__logins--active");
                brand_bar.css("margin-top", panel_height);
            }

            $("#menu--logins").on("focusout", function (event) {
                if (!this.contains(event.relatedTarget)) {
                    logins_panel
                        .removeClass("panel__logins--active")
                        .attr("aria-hidden", "true");
                    logins_toggle
                        .removeClass("toggle__logins--active")
                        .attr("aria-expanded", "false");
                    brand_bar.removeAttr("style");
                }
            });
        });

        var personas_toggle = $("#toggle__personas");

        // Toggle personas panel when tapping button
        personas_toggle.click(function () {
            var panel_height = personas_panel.outerHeight();

            if (
                $("#menu--primary").length > 0 &&
                $(this).hasClass("toggle__personas--active")
            ) {
                personas_toggle
                    .attr("aria-expanded", "false")
                    .removeClass("toggle__personas--active");
                personas_panel
                    .attr("aria-hidden", "true")
                    .removeClass("panel__personas--active");
                brand_bar.removeAttr("style");
            } else if (
                $("#menu--primary").length < 1 &&
                $(window).width() > 959 &&
                $(this).hasClass("toggle__personas--active")
            ) {
                personas_toggle
                    .attr("aria-expanded", "false")
                    .removeClass("toggle__personas--active");
                personas_panel
                    .attr("aria-hidden", "true")
                    .removeClass("panel__personas--active");
                brand_bar.removeAttr("style");
            } else {
                resources_toggle
                    .attr("aria-expanded", "false")
                    .removeClass("toggle__resources--active");
                resources_panel
                    .attr("aria-hidden", "true")
                    .removeClass("panel__resources--active");
                logins_toggle
                    .attr("aria-expanded", "false")
                    .removeClass("toggle__logins--active");
                logins_panel
                    .attr("aria-hidden", "true")
                    .removeClass("panel__logins--active");
                search_toggle
                    .attr("aria-expanded", "false")
                    .removeClass("toggle__search--active");
                search_panel
                    .removeClass("panel__search--active");

                personas_toggle
                    .attr("aria-expanded", "true")
                    .addClass("toggle__personas--active");
                personas_panel
                    .attr("aria-hidden", "false")
                    .addClass("panel__personas--active");
                brand_bar.css("margin-top", panel_height);
            }

            $("#menu--personas").on("focusout", function (event) {
                if (!this.contains(event.relatedTarget)) {
                    personas_panel
                        .removeClass("panel__personas--active")
                        .attr("aria-hidden", "true");
                    personas_toggle
                        .removeClass("toggle__personas--active")
                        .attr("aria-expanded", "false");
                    brand_bar.removeAttr("style");
                }
            });
        });
    }

    function destroyBrandBar() {
        var site_title = $("#site__title");
        var logo_bar = $("#site__bar--logo");
        var menu_bar = $("#site__bar--menu");
        var alert_toggle = $("#toggle__alert");
        var search_toggle = $("#toggle__search");
        var search_panel = $("#panel__search");
        var site_bar = $("#site__bar");
        var menu_toggle_html =
            '<button id="toggle__menu" class="toggle__menu">Menu</button>';

        // Move search panel back to original location
        search_panel.prependTo(site_bar);

        // Register menu toggle
        site_title.appendTo(site_bar.find("> .wrapper"));
        alert_toggle.appendTo(site_bar.find("> .wrapper"));
        search_toggle.appendTo(site_bar.find("> .wrapper"));
        site_bar.find("> .wrapper").append(menu_toggle_html);

        // Deregister bars
        logo_bar.remove();
    }

    function buildSiteMenu() {
        var header = $("#header-container");
        var site_menu = $("#site__menu");
        var personas_menu = $("#menu--personas");
        var primary_menu = $("#menu--primary");

        if (header.hasClass("header-container--university")) {
            primary_menu.unwrap();
        }

        // Move menus from panels to site menu
        primary_menu.appendTo(site_menu);
        //logins_menu.appendTo(site_menu);
        //resources_menu.appendTo(site_menu);
        personas_menu.appendTo(site_menu);
    }

    function destroySiteMenu() {
        var header = $("#header-container");
        var site_title = $("#site__title");
        var site_menu = $("#site__menu");
        var primary_menu = $("#menu--primary");
        var site_bar = $("#site__bar");
        var personas_panel = $("#panel__personas");

        // Add/move components from site menu to site bar
        site_title.appendTo(site_bar.find(".wrapper"));

        if (
            header.hasClass("header-container--university") &&
            !header.hasClass("header--minimal")
        ) {
            var menus = site_bar.find(".wrapper .menus");

            if (menus.length === 0) {
                var menusDiv = $('<div class="menus"></div>');
                menusDiv.append(primary_menu);

                site_bar.find(".wrapper").append(menusDiv);
            } else {
                menus.append(primary_menu);
            }
        } else if (header.hasClass("header-container--persona")) {
            primary_menu.appendTo(site_bar);
        } else {
            primary_menu.appendTo(site_bar);
        }

        var personas_menu = personas_panel.find(".wrapper #menu--personas");
        if (personas_menu.length === 0) {
            $("#menu--personas").appendTo("#panel__personas .wrapper");
        }

        // Hide site menu (preserve DOM for mobile-menu-header)
        site_menu.removeClass("site__menu--active");

        // Reset positions on bars
        site_bar.removeAttr("style");
    }

    function buildStickyMenu() {
        var primary_menu = $("#menu--primary");

        // Check to see if we have a primary menu
        if (primary_menu.length && typeof ScrollMagic == "function") {
            // initialize controller
            var controller = new ScrollMagic.Controller({
                addIndicators: false, // toggle to debug (requires plugin)
            });

            // setup scene
            var scene = new ScrollMagic.Scene({
                triggerElement: "#menu--primary",
                triggerHook: 0,
            })
                .setPin("#menu--primary")
                .addTo(controller);
        }
    }

    function destroyStickyMenu() {
        var primary_menu = $("#menu--primary");

        // Check to see if we have a primary menu
        if (primary_menu.length && typeof ScrollMagic == "function") {
            primary_menu.removeAttr("style").unwrap();
        }
    }

    function escapeToggles() {
        $(document).keyup(function (e) {
            var escaped = e.keyCode == 27;
            var active_mobile_menu = $("#site__menu").hasClass(
                "site__menu--active"
            );
            var active_resources_panel = $("#panel__resources").hasClass(
                "panel__resources--active"
            );
            var active_logins_panel = $("#panel__logins").hasClass(
                "panel__logins--active"
            );
            var active_personas_panel = $("#panel__personas").hasClass(
                "panel__personas--active"
            );
            var active_search_panel = $("#panel__search").hasClass(
                "panel__search--active"
            );
            var active_alerts_panel = $("#panel__alerts").hasClass(
                "panel__alerts--active"
            );

            // If mobile menu or panels are open, close them when hitting ESC key
            if (escaped && active_mobile_menu) {
                if (typeof window.closeMobileMenu === 'function') {
                    window.closeMobileMenu();
                } else {
                    console.log("closeMobileMenu function not found");
                }
            } else if (escaped && active_resources_panel) {
                $("#toggle__resources").trigger("click");
            } else if (escaped && active_logins_panel) {
                $("#toggle__logins").trigger("click");
            } else if (escaped && active_personas_panel) {
                $("#toggle__personas").trigger("click");
            } else if (escaped && active_search_panel) {
                $("#toggle__search").trigger("click");
            } else if (escaped && active_alerts_panel) {
                $(".alert__close").trigger("click");
            }
        });
    }

    function subMenus() {
        $(".submenu-toggle").on("click", function () {
            $(".panel__mega").removeClass("panel__mega--active");
            var $panel = $(this).next(".panel__mega");
            $panel.addClass("panel__mega--active");
            updateSubmenuInert();

            setTimeout(function () {
                $panel.find(".back a").first().focus();
            }, 200);
        });

        $(".submenu-toggle").on("keypress", function () {
            $(".panel__mega").removeClass("panel__mega--active");
            var $panel = $(this).next(".panel__mega");
            $panel.addClass("panel__mega--active");
            updateSubmenuInert();

            setTimeout(function () {
                $panel.find(".back a").first().focus();
            }, 200);
        });

        $(".current-page-ancestor")
            .find(".panel__mega")
            .addClass("panel__mega--active");
        updateSubmenuInert();
    }

    function closeSubMenu() {
        $(".menu-item-has-children").removeClass("open");
    }

    function keyboardNav() {
        $(".submenu-toggle").on("click", function () {
            $(this)
                .parent($(".menu-item-has-children"))
                .siblings($(".menu-item-has-children"))
                .removeClass("open");
            if ($(this).parent($(".menu-item-has-children")).hasClass("open")) {
                $(this)
                    .parent($(".menu-item-has-children"))
                    .removeClass("open");
            } else {
                $(this).parent($(".menu-item-has-children")).addClass("open");
            }
        });

        $(document).keyup(function (e) {
            if (e.keyCode == 27) {
                closeSubMenu();
            }
        });

        $(".menu-item-has-children > a").on("focus", function () {
            closeSubMenu();
        });

        $("#menu--primary").on("focusout", function (event) {
            if (!this.contains(event.relatedTarget)) {
                $(".menu-item-has-children").removeClass("open");
            }
        });
    }

    /* Function addMobileBackMenuItem
  /* Adds a 'back' arrow and link on mobile sub nav panels
    ------------------------------------------------------------------------ */
    function addMobileBackMenuItem() {
        var primaryMenu = $("#primary-menu"),
            subMenu = $("#primary-menu .panel__mega");
        subMenu.prepend(
            '<div class="back"><a href="#"><span class="nav-arrow"></span> Back</a></div>'
        );
        toggleBack();

        function toggleBack() {
            $(".panel__mega .back").on("click", function (e) {
                e.preventDefault();
                var $panel = $(this).closest(".panel__mega");
                var $toggle = $panel.prev(".submenu-toggle");
                $panel.removeClass("panel__mega--active");
                updateSubmenuInert();

                setTimeout(function () {
                    $toggle.focus();
                }, 200);
            });
        }
    }

    // Add `inert` to items covered by an open submenu so they're skipped
    // by both TAB and screen-reader virtual cursor (i.e. arrow keys) navigation.
    function updateSubmenuInert() {
        var $allMenuItems = $("#primary-menu > li");
        // Anything else inside #site__menu that the panel covers visually.
        var $coveredOutsideActiveItem = $("#menu--primary .menu-title").add("#menu--personas");
        var $activePanel = $("#site__menu").find(".panel__mega--active").first();

        if ($activePanel.length > 0) {
            var $activeItem = $activePanel.closest("li");
            $allMenuItems.not($activeItem).attr("inert", "");
            $activeItem.removeAttr("inert");
            $activeItem.children("a, .submenu-toggle").attr("inert", "");
            $coveredOutsideActiveItem.attr("inert", "");
        } else {
            $allMenuItems.removeAttr("inert");
            $allMenuItems.children("a, .submenu-toggle").removeAttr("inert");
            $coveredOutsideActiveItem.removeAttr("inert");
        }
    }

    jQuery(document).ready(function () {
        brandToggles();
        subMenus();
        addMobileBackMenuItem();
        keyboardNav();

        if ($("#menu--primary").length < 1) {
            $("#toggle__menu").on("click", function () {
                var $resourcesPanel = $("#panel__resources");
                var $loginsPanel = $("#panel__logins");
                var $resourcesToggle = $("#toggle__resources");

                $resourcesPanel.toggleClass("panel__resources--active");
                $resourcesToggle.toggleClass("toggle__resources--active");

                if ($resourcesPanel.hasClass("panel__resources--active")) {
                    $resourcesPanel
                        .removeAttr("aria-hidden");
                } else {
                    $resourcesPanel
                        .attr("aria-hidden", "true");
                }

                // Close both panels if logins are open
                if ($loginsPanel.hasClass("panel__logins--active")) {
                    $loginsPanel
                        .removeClass("panel__logins--active")
                        .attr("aria-hidden", "true");

                    $resourcesPanel
                        .removeClass("panel__resources--active")
                        .attr("aria-hidden", "true");
                }
            });
        }

        $("#colophon-menu").prepend($("#copyright"));
    });

    // Laptop/Desktop:
    // Restructure header to include brand bar and site bar
    enquire.register("screen and (min-width: 1175px)", {
        // =====================================================
        // Triggered when a media query matches
        // =====================================================
        match: function () {
            destroyToggleMenu();
            buildBrandBar();
            destroySiteMenu();
            buildStickyMenu();
        },

        // =====================================================
        // Triggered when a media query transitions from a
        // matched state to an unmatched state
        // =====================================================
        unmatch: function () {
            destroyStickyMenu();
            buildSiteMenu();
            destroyBrandBar();
            buildToggleMenu();
        },

        // =====================================================
        // Triggered once, when the handler is registered
        // =====================================================
        setup: function () {
            buildToggleMenu();
            escapeToggles();
        },
    });
})(jQuery);
